import { CollectionName } from '../../constants';
import { ContactType } from '../../models/contact.dto';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const keysToMigrate = [
  // Individual
  'powers',
  // Legal Entity
  'ownerDocument',
  'ownerOtherDocument',
  'documents',
  // Bank & Broker
  'businessCard',
  'contract',
  'paymentDetails',
  'statement',
  'recommendations',
  // Bank
  'bankFilesAndOther',
  // Broker
  'brokerFilesAndOther',
];

const migrateContact = (data: CurrentMigrationCollectionItem): MigratedMigrationCollectionItem => {
  const newData = { ...data };

  const contactType = data.type as ContactType;

  for (const key in data) {
    if (!keysToMigrate.includes(key)) {
      continue;
    }

    if (contactType === ContactType.INDIVIDUAL && key === 'businessCard') {
      const businessCardFilePath = data.businessCard as string | string[];

      if (Array.isArray(businessCardFilePath)) {
        newData.businessCardFile = businessCardFilePath[0];
      } else {
        newData.businessCardFile = businessCardFilePath;
      }
      newData.businessCard = [];

      continue;
    }

    const value = data[key];

    if (Array.isArray(value)) {
      continue;
    }

    newData[key] = [value];
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.CONTACTS, migrateItemFunction: migrateContact },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration1: MigrationType = {
  migrate,
  version: 2,
};
